var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":"","nudge-width":200,"close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":"warning","light":""}},'v-btn',attrs,false),on),[_vm._v(" Dev Toolbox ")])]}}])},[_c('v-card',[_c('v-card-title',[_vm._v("Dev Toolbox")]),_c('ToolboxUser')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }